import { render, staticRenderFns } from "./InputTag.vue?vue&type=template&id=06474ba0&scoped=true"
import script from "./InputTag.vue?vue&type=script&lang=js"
export * from "./InputTag.vue?vue&type=script&lang=js"
import style0 from "./InputTag.vue?vue&type=style&index=0&id=06474ba0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06474ba0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06474ba0')) {
      api.createRecord('06474ba0', component.options)
    } else {
      api.reload('06474ba0', component.options)
    }
    module.hot.accept("./InputTag.vue?vue&type=template&id=06474ba0&scoped=true", function () {
      api.rerender('06474ba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InputTag.vue"
export default component.exports